import { CONSTANTS } from '../data';
import { GameState } from './GameState';

type HorrorMessageCallback = (message: any) => void;

export class EnvironmentalHorrorSystem {
  private timer: NodeJS.Timeout | null = null;
  private gameState = GameState.getInstance();
  private callback: HorrorMessageCallback | null = null;

  public start(callback: HorrorMessageCallback) {
    this.callback = callback;
    this.scheduleNextMessage();
  }

  public stop() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    this.callback = null;
  }

  private scheduleNextMessage() {
    if (!this.callback) return;

    const { timeLeft } = this.gameState;
    const totalTime = CONSTANTS.SYSTEM_COLLAPSE_TIMER.initialDurationSeconds;
    const healthPercentage = (timeLeft / totalTime) * 100;

    let baseFrequency: number;
    if (healthPercentage < 20) {
      baseFrequency = CONSTANTS.ENVIRONMENTAL_HORROR.nearDeathFrequencyMs;
    } else if (healthPercentage < 50) {
      baseFrequency = CONSTANTS.ENVIRONMENTAL_HORROR.criticalFrequencyMs;
    } else {
      baseFrequency = CONSTANTS.ENVIRONMENTAL_HORROR.initialFrequencyMs;
    }

    const nextDelay = baseFrequency + Math.random() * CONSTANTS.ENVIRONMENTAL_HORROR.randomnessMs;

    this.timer = setTimeout(() => {
      if (!this.gameState.gamePaused && this.callback) {
        this.triggerMessage();
      }
      this.scheduleNextMessage();
    }, nextDelay);
  }

  private triggerMessage() {
    if (!this.callback) return;
    const messages = CONSTANTS.ENVIRONMENTAL_HORROR.messages;
    const message = messages[Math.floor(Math.random() * messages.length)];
    this.callback(message);
  }
}
